<qrcode [qrdata]="url" [width]="width" [errorCorrectionLevel]="'M'" *ngIf="showQRCode && url"></qrcode>